import script from "./detail.vue?vue&type=script&setup=true&lang=js"
export * from "./detail.vue?vue&type=script&setup=true&lang=js"

import "./detail.vue?vue&type=style&index=0&id=378910d4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-378910d4"]])

export default __exports__